<template>
<div class="page-container">
  <el-row :gutter="20">
    <el-col :md="8" :sm="24">
      <div class="card card-height">
        <span><i class="el-icon-collection"></i>{{ $t('缓存分类') }}</span>
        <el-button
          @click="refreshCacheTypes()"
          style="float: right; padding: 3px 0"
          type="text" icon="el-icon-refresh-right"></el-button>
        <el-divider></el-divider>
        <el-table
          :data="pagedCacheTypes"
          v-loading="typeLoading"
:element-loading-text="$t('正在加载缓存分类')"
          @row-click="getCacheKeys"
          highlight-current-row
          :header-cell-style="{ background: '#fff' }" border>
          <template slot="empty">
            <el-empty :image-size="200"></el-empty>
          </template>
          <el-table-column :label="$t('序号')" width="50" type="index"  align="center"></el-table-column>
          <el-table-column prop="name" :label="$t('缓存名称')"  align="center" :formatter="nameFormatter"></el-table-column>
          <el-table-column prop="remark" :label="$t('备注')"  align="center"></el-table-column>
          <el-table-column :label="$t('操作')"  align="center" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-delete" @click="clearCacheKeys(scope.row)"></el-button>
            </template>
            </el-table-column>
        </el-table>
        <pagination :total="cacheTypes.length" :page.sync="typePage" :limit.sync="typePageSize" layout="total, sizes, prev, next" :auto-scroll="false" />
      </div>
    </el-col>
    <el-col :md="8" :sm="24">
      <div class="card card-height">
        <span><i class="el-icon-key"></i>{{ $t('缓存列表') }}</span>
        <el-button
          @click="refreshCacheKeys"
          style="float: right; padding: 3px 0"
          type="text"
          icon="el-icon-refresh-right"></el-button>
        <el-divider></el-divider>
        <el-table
          :data="pagedCacheKeys"
          v-loading="keyLoading"
          @row-click="getCacheInfoByKey"
:element-loading-text="$t('正在加载缓存列表')"
          highlight-current-row
          :header-cell-style="{ background: '#fff' }" border>
          <template slot="empty">
            <el-empty :image-size="200"></el-empty>
          </template>
          <el-table-column :label="$t('序号')" type="index"  align="center" width="50"></el-table-column>
          <el-table-column :label="$t('缓存键名')"  align="center" prop="showKey" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('操作')"  align="center" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-delete" @click="deleteCacheKey(scope.row)"></el-button>
            </template>
            </el-table-column>
        </el-table>
        <pagination :total="cacheKeys.length" :page.sync="keyPage" :limit.sync="keyPageSize" layout="total, sizes, prev, next" :auto-scroll="false" />
      </div>
    </el-col>
    <el-col :md="8" :sm="24">
      <div class="card card-height">
        <span><i class="el-icon-document"></i>{{ $t('缓存内容') }}</span>
        <el-divider></el-divider>
        <el-form :model="cacheForm" v-loading="cacheLoading" :element-loading-text="$t('正在加载缓存信息')">
          <el-row :gutter="32">
            <el-col>
              <el-form-item :label="$t('缓存名称:')" prop="cacheName">
                <el-input v-model="cacheForm.cacheName" :readOnly="true" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('缓存键名:')" prop="cacheKey">
                <el-input v-model="cacheForm.cacheKey" :readOnly="true" />
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="$t('缓存内容:')" prop="cacheValue">
                <el-input
                  v-model="cacheForm.cacheValue"
                  type="textarea"
                  :rows="9"
                  :readOnly="true"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-col>
  </el-row>

</div>
</template>

<script>
import { translateUi } from '../../../i18n'
import { listCacheType, listCacheKeys, getCacheInfoByKey, clearCacheKeys, deleteCacheKey } from '../../../api/monitor/cache'
import Pagination from '../../../components/Pagination'

export default {
  name: 'Cache',
  components: { Pagination },

  data () {
    return {
      // 是否展示缓存键类型加载框
      typeLoading: false,
      // 是否展示缓存键加载框
      keyLoading: false,
      // 缓存信息等待框
      cacheLoading: false,
      // 缓存键类型
      cacheTypes: [],
      typePage: 1,
      typePageSize: 20,
      // 缓存键
      cacheKeys: [],
      keyPage: 1,
      keyPageSize: 20,
      // 缓存信息
      cacheForm: {
        // 缓存名称
        cacheName: undefined,
        // 缓存键
        cacheKey: undefined,
        // 缓存值
        cacheValue: undefined
      },
      // 当前选中缓存名称
      cacheName: undefined
    }
  },

  created () {
    // 获取表格内容
    this.listCacheType()
  },

  computed: {
    pagedCacheTypes () {
      return this.cacheTypes.slice((this.typePage - 1) * this.typePageSize, this.typePage * this.typePageSize)
    },
    pagedCacheKeys () {
      return this.cacheKeys.slice((this.keyPage - 1) * this.keyPageSize, this.keyPage * this.keyPageSize)
    }
  },

  methods: {
    // 获取表格内容
    listCacheType () {
      // 打开加载框
      this.typeLoading = true
      listCacheType().then((res) => {
        this.cacheTypes = res
        if ((this.typePage - 1) * this.typePageSize >= res.length) this.typePage = 1
        // 关闭加载框
        this.typeLoading = false
      }).catch(() => {
        // 关闭加载框
        this.typeLoading = false
      })
    },
    // 刷新Redis缓存键类型
    refreshCacheTypes () {
      // 重新获取缓存名称
      this.listCacheType()
      // 输出提示信息
      this.$message.success(translateUi('缓存名称刷新成功'))
    },
    // 刷新Redis缓存键
    refreshCacheKeys () {
      // 重新获取缓存名称
      this.getCacheKeys()
      // 输出提示信息
      this.$message.success(translateUi('缓存键刷新成功'))
    },
    // 获取对应缓存键列表
    getCacheKeys (row) {
      // 获取当前选中类型
      const cacheName = row !== undefined ? row.name : this.cacheName
      // 加载框
      this.keyLoading = true
      listCacheKeys(cacheName).then((res) => {
        this.cacheKeys = res
        if (row !== undefined || (this.keyPage - 1) * this.keyPageSize >= res.length) this.keyPage = 1
        // 赋值当前选中缓存名称
        this.cacheName = cacheName
        // 关闭加载框
        this.keyLoading = false
      }).catch(() => {
        // 确保加载框关闭
        this.keyLoading = false
      })
    },
    // 获取指定缓存信息
    getCacheInfoByKey (row) {
      // 加载框
      this.cacheLoading = true
      getCacheInfoByKey(row.key).then((res) => {
        this.cacheForm = res
        // 关闭加载框
        this.cacheLoading = false
      }).catch(() => {
        // 确保加载框关闭
        this.cacheLoading = false
      })
    },
    // 清除缓存列表
    clearCacheKeys (row) {
      this.$confirm(translateUi('是否清除缓存列表 ') + row.name + ' ?', translateUi('系统提示'), {
        confirmButtonText: translateUi('确定'),
        cancelButtonText: translateUi('取消'),
        type: 'warning'
      }).then(() => {
        // 加载等待框
        this.keyLoading = true
        clearCacheKeys(row.name).then((res) => {
          // 刷新缓存列表
          this.getCacheKeys()
          // 关闭等待框
          this.keyLoading = false
          this.$message.success(translateUi('缓存列表清除成功'))
        }).catch(() => {
          this.keyLoading = false
        })
      }).catch(() => {})
    },
    // 删除指定缓存
    deleteCacheKey (row) {
      this.$confirm(translateUi('是否删除缓存 ') + row.showKey + ' ?', translateUi('系统提示'), {
        confirmButtonText: translateUi('确定'),
        cancelButtonText: translateUi('取消'),
        type: 'warning'
      }).then(() => {
        // 加载等待框
        this.cacheLoading = true
        deleteCacheKey(row.key).then((res) => {
          // 刷新缓存列表
          this.getCacheKeys()
          // 关闭等待框
          this.cacheLoading = false
          this.$message.success(translateUi('缓存删除成功'))
        }).catch(() => {
          this.keyLoading = false
        })
      }).catch(() => {})
    },
    // 去除掉缓存键名后的冒号
    nameFormatter (row) {
      return row.name.replace(':', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  height: 40px;
}
.el-divider {
  margin: 10px 0;
  width: 100%;
}
.card-height {
  i {
    margin-right: 5px;
  }
}
</style>
